export class DataFromUrl
{
    getJobId()
    {
        var job_id = window.location.pathname.split('/').slice(-2)[0];
        if(job_id == 'jobs') return null
        return job_id;
    }

    getClientId()
    {
        var client_id = window.location.pathname.split('/').slice(-2)[0];
        if(client_id == 'clients') return null
        return client_id;
    }
}